import script from "./AutoTransferOptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoTransferOptions.vue?vue&type=script&setup=true&lang=ts"

import "./AutoTransferOptions.vue?vue&type=style&index=0&id=d0043d56&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0043d56"]])

export default __exports__